import ViewerModel from "./ViewerModel.js";
import ViewerSelector from "./ViewerSelector.js"; // import EditLayoutAction from './actions/EditLayoutAction'
import ResetLayoutAction from "./actions/ResetLayoutAction.js";
import RevertLayoutAction from "./actions/RevertLayoutAction.js";
import SaveAsLayoutAction from "./actions/SaveAsLayoutAction.js";
import SaveLayoutAction from "./actions/SaveLayoutAction.js";
import EditLayoutsActionCreator from "./actions/EditLayoutsActionCreator.js";
import ResetCustomLayoutAction from "./actions/ResetCustomLayoutAction.js";
import DefaultLayoutAction from "./actions/DefaultLayoutAction.js";
import LayoutAction from "./actions/LayoutAction.js";
import LayoutSelector from "./actions/LayoutSelector.js";
import LayoutVersions from "./LayoutVersions.js";
import UserSettingsDefaultLayoutDelegate from "./UserSettingsLayoutDelegate.js";
const install = molten => {
  LayoutVersions.setDelegate(UserSettingsDefaultLayoutDelegate);

  // molten.addPlugin( 'Action', EditLayoutAction )
  molten.addPlugin('Action', ResetLayoutAction);
  molten.addPlugin('Action', RevertLayoutAction);
  molten.addPlugin('Action', SaveAsLayoutAction);
  molten.addPlugin('Action', SaveLayoutAction);
  molten.addPlugin('Action', EditLayoutsActionCreator);
  molten.addPlugin('Action', ResetCustomLayoutAction);
  molten.addPlugin('Action', DefaultLayoutAction);
  molten.addPlugin('Action', LayoutAction);
  molten.addPlugin('Action', LayoutSelector);
  molten.addPlugin('ModelEditor', {
    type: ViewerModel.OLD_TYPE,
    editor: ViewerSelector
  });
  molten.addPlugin('ModelEditor', {
    type: ViewerModel.TYPE,
    editor: ViewerSelector
  });
};
export default {
  install
};